import React, { useState, useEffect } from "react";
import AsideLeft from "./AppAdminComponents/AsideLeft";
import NavBarNotificationBar from "./AppAdminComponents/NavBarNotificationBar";
import { get, post } from "../helpers/api.helper";
import formatMoney from "../helpers/money.helper";
import { GetCustomer, GetCustomerByUser } from "../services/customer.service";
import { toast } from "react-toastify";
import "font-awesome/css/font-awesome.min.css";
import { useNavigate } from "react-router-dom";
import { isCustomerUser } from "../helpers/user.helper";
import Swal from "sweetalert2";
import Modal from "react-modal";
import { getuser } from "../helpers/user.helper";
import Footer from "../components/Footer";

export default function NovaVenda() {
  let navigate = useNavigate();
  const [Products, setProducts] = useState([]);
  const [codProd, setcodProd] = useState(undefined);
  const [codCliente, setcodCli] = useState(undefined);
  const [QtdItem, setQtdItem] = useState(undefined);
  const [isLoader, setIsloader] = useState(false);
  const [isLoaderFinsh, setisLoaderFinsh] = useState(false);
  const [cliente, setCliente] = useState(undefined);
  const [finalCheckout, setFinalCheckout] = useState(undefined);
  const [cpfGarantia, cpfHandleChange] = useState(undefined);
  const [emailGarantia, emailHandleChange] = useState(undefined);

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [isLoadingChange, setisLoadingChange] = useState(false);

  useEffect(() => {
    if (isCustomerUser()) {
      async function fetchData() {
        let customer = await GetCustomerByUser();
        setcodCli(customer?.data?.codigo);
        setCliente(customer?.data);
      }

      fetchData();
    }
  }, []);

  const addProduct = async () => {
    if (codProd) {
      let existing = Products.filter((item) => item.codProd === codProd);

      if (existing.length > 0) {
        toast.info(
          `O produto ${codProd} já foi adicionado a lista. Caso deseje basta aumentar sua quantidade`
        );
        return;
      } else {
        setIsloader(true);
        let tempProd = Products;
        let getProd = await get(`produto/cplus/${codProd}`);

        if (getProd.data.length > 0) {
          tempProd.push(getProd.data[0]);
          setProducts(tempProd);
        }

        setcodProd('');
        setIsloader(false);
      }
    }
  };

  const getTotal = (total, num, qtd) => {
    let preco = parseFloat(num.preco) * (num.qtd || 1);
    return total + Math.round(preco);
  };

  const removeItem = (key) => {
    Swal.fire({
      title: "Tem certeza??",
      text: "Atenção deseja apagar o item selecionado?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Sim, remover.",
    }).then((result) => {
      if (result.value) {
        let array = Products.filter((item) => item.id !== key);
        setProducts(array);
      }
    });
  };

  const handleChangeQtd = (value, key) => {
    Products.map((item) => {
      if (item.id === key) {
        item.qtd = value;
      }
    });
    setProducts(Products);
    setcodProd(undefined);
    setQtdItem(value);
  };

  const handleChangeEmailGarantia = (value, key) => {
    Products.map((item) => {
      if (item.id === key) {
        item.email_garantia = value;
      }
    });
    setProducts(Products);
    setcodProd(undefined);
    setQtdItem(value);
  };

  const handleChangeCpfGarantia = (value, key) => {
    Products.map((item) => {
      if (item.id === key) {
        item.cpf_garantia = value;
      }
    });
    setProducts(Products);
    setcodProd(undefined);
    setQtdItem(value);
  };

  const searchCustomer = async (e) => {
    if (e) {
      let codCustomer = e;
      let customer = await GetCustomer(codCustomer);
      setCliente(customer?.data[0]);
    }
  };

  const sendVenda = async (submitVenda) => {
    let result = await post("FinalizaVenda", submitVenda);

    if (result?.status === 200) {
      Swal.fire(`Venda concluída com sucesso. Você ganhou ${result.data} pontos pela venda!`, "", "success");
      navigate("/vendas");
    } else {
      Swal.fire("Ops!", "Ocorreu um erro ao finalizar a venda.", "error");
    }
  };

  const handleClickVenda = async () => {
    if (!codCliente) {
      Swal.fire(
        "É necessário informar um cliente antes de prosseguir! ",
        "",
        "warning"
      );
      return;
    } else if (Products.length == 0) {
      Swal.fire(
        "É necessário informar ao menos um produto para finalizar a venda! ",
        "",
        "warning"
      );
      return;
    }

    setisLoaderFinsh(true);
    let submitProducts = [];
    Products.map((item) => {
      submitProducts.push({
        codProduto: item.codProduto,
        qtdProduto: parseInt(item.qtd),
        emailGarantia: item.email_garantia,
        cpfGarantia: item.cpf_garantia,
        garantia: item.cpf_garantia !== undefined ? true : false,
      });
    });

    let submitVenda = { codCliente: codCliente, itens: submitProducts };
    setFinalCheckout(submitVenda);

    if (!isCustomerUser()) {
      sendVenda(submitVenda);
    } else {
      openModal();
    }

    setisLoaderFinsh(false);
  };

  function openModal() {
    setIsOpen(true);
  }

  function closeModal() {
    setIsOpen(false);
  }

  const cancelModal = () => {
    closeModal();
  };

  const saveDataAndCloseModal = async () => {
    setisLoadingChange(true);

    let submitVenda = finalCheckout;
    submitVenda.garantia = {
      cpf: cpfGarantia,
      email: emailGarantia,
    };

    sendVenda(submitVenda);

    closeModal();
    setisLoadingChange(false);
  };

  const customStyles = {
    content: {
      width: "60%",
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
    },
  };

  return (
    <>
      <div className="wrapper">
        <div>
          <Modal
            isOpen={modalIsOpen}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <h2>Preencha os Dados da Garantia</h2>
            <div className="row">
              <div className="col-6">
                <div className="form-group">
                  <label>CPF</label>
                  <input
                    type="text"
                    name="cpf"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    onChange={(e) => cpfHandleChange(e.target.value)}
                  />
                </div>
              </div>
              <div className="col-6">
                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="text"
                    name="email"
                    className="form-control"
                    id="exampleInputEmail1"
                    aria-describedby="emailHelp"
                    onChange={(e) => emailHandleChange(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group">
                  <button
                    className="btn btn-primary"
                    onClick={() => cancelModal()}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn btn-success"
                    onClick={() => saveDataAndCloseModal()}
                  >
                    <span
                      className={
                        isLoadingChange
                          ? " spinner-border spinner-border-sm"
                          : ""
                      }
                    ></span>{" "}
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        {/* Navbar */}
        <nav className="main-header navbar navbar-expand navbar-white navbar-light">
          <NavBarNotificationBar />
        </nav>
        <AsideLeft option="vendas" />
        <div className="content-wrapper">
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 text-dark">
                    {getuser().type == "C" ? "Nova Compra" : "Nova Vendas"}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                {/* Left col */}
                <section className="col-12 connectedSortable">
                  {/* Custom tabs (Charts with tabs)*/}
                  <div className="card">
                    <div className="card-header">
                      <div className="card-tools"></div>
                    </div>
                    <div className="card-body">
                      <div className="tab-content p-0">
                        <div className="row">
                          <div className="col-2">
                            <div className="form-group">
                              <input
                                type="text"
                                required
                                placeholder="Cód Do Cliente"
                                value={codCliente}
                                onBlur={(e) => searchCustomer(e.target.value)}
                                className="form-control"
                                aria-describedby="codProduto"
                                name="nome"
                                onChange={(e) => setcodCli(e.target.value)}
                                readOnly={isCustomerUser() ? true : false}
                              />
                            </div>
                          </div>
                          <div className="col-10">
                            <div className="form-group">
                              <input
                                type="text"
                                required
                                placeholder="Nome Cliente"
                                value={cliente?.nome}
                                className="form-control"
                                aria-describedby="codProduto"
                                name="nome"
                                readOnly="true"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-11">
                            <div className="form-group">
                              <input
                                type="text"
                                required
                                placeholder="Código Do Produto"
                                value={codProd}
                                className="form-control"
                                aria-describedby="codProduto"
                                name="nome"
                                onChange={(e) => setcodProd(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-1">
                            <div className="form-group">
                              <button
                                type="button"
                                id="submit-btn"
                                className={`btn btn-primary`}
                                onClick={() => addProduct()}
                              >
                                <span
                                  className={
                                    isLoader
                                      ? " spinner-border spinner-border-sm"
                                      : ""
                                  }
                                ></span>{" "}
                                {!isLoader ? "Buscar" : ""}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="panel panel-info">
                        <div className="panel-heading"></div>
                        <div className="panel-body">
                          {Products.map((item) => {
                            return (
                              <>
                                <div className="row" key={item.id}>
                                  <div className="col-2">
                                    <img
                                      className="img-responsive"
                                      src="http://placehold.it/100x70"
                                    />
                                  </div>
                                  <div className="col-4">
                                    <h4 className="product-name">
                                      <strong>{item.descricao}</strong>
                                    </h4>
                                    <h4>
                                      <small>{item.descricao}</small>
                                    </h4>
                                  </div>
                                  <div className="col-4">
                                    <div className="col-4">
                                      <input
                                        type="number"
                                        name="produto"
                                        min={1}
                                        className="form-control input-sm"
                                        defaultValue={item.qtd || 1}
                                        onChange={(e) =>
                                          handleChangeQtd(
                                            e.target.value,
                                            item.id
                                          )
                                        }
                                      />
                                      <h6>
                                        <strong>
                                          <span className="text-muted">x </span>
                                          {formatMoney(item.preco)}{" "}
                                        </strong>
                                      </h6>
                                    </div>
                                    <div className="col-4">
                                      <fieldset>
                                        <legend>Garantia:</legend>
                                        CPF
                                        <input
                                          type="text"
                                          name="cpf"
                                          className="form-control input-sm"
                                          placeholder="CPF garantia"
                                          onChange={(e) =>
                                            handleChangeCpfGarantia(
                                              e.target.value,
                                              item.id
                                            )
                                          }
                                        />
                                        Email
                                        <input
                                          type="text"
                                          name="email"
                                          className="form-control input-sm"
                                          placeholder="Email garantia"
                                          onChange={(e) =>
                                            handleChangeEmailGarantia(
                                              e.target.value,
                                              item.id
                                            )
                                          }
                                        />
                                      </fieldset>
                                    </div>
                                  </div>
                                  <div className="col-2">
                                    <h4 className="product-name">
                                      <strong>
                                        {formatMoney(
                                          parseInt(item.qtd || 1) *
                                            parseFloat(item.preco)
                                        )}
                                      </strong>
                                    </h4>
                                    <div className="col-2">
                                      <button
                                        type="button"
                                        className="btn btn-link btn-xs"
                                        onClick={() => removeItem(item.id)}
                                      >
                                        <span className="fa fa-trash"> </span>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <hr />
                              </>
                            );
                          })}
                          <hr />
                        </div>
                        <div className="panel-footer">
                          <div className="row text-center">
                            <div className="col-9">
                              <h4 className="text-right">
                                Total{" "}
                                <strong>
                                  {formatMoney(Products.reduce(getTotal, 0))}
                                </strong>
                              </h4>
                            </div>
                            <div className="col-3">
                              <button
                                type="button"
                                className="btn btn-success btn-block"
                                onClick={() => handleClickVenda()}
                              >
                                <span
                                  className={
                                    isLoaderFinsh
                                      ? " spinner-border spinner-border-sm"
                                      : ""
                                  }
                                ></span>{" "}
                                {!isLoaderFinsh ? "Finalizar" : ""}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}
